import { StreetAddress } from '@/license/components/license-content-styles';
import { SummarizedComplaintsSkeleton } from '@/placeholders/skeleton-placeholders/summarized-complaints-skeleton';
import {
  DetailsWrapper,
  Wrapper,
} from '@/property-details/components/property-details-content-styles';
import { useComplaints } from '@/utils/hooks/data/useComplaints';
import { usePropertyDetails } from '@/utils/hooks/data/usePropertyDetails';
import styled from 'styled-components';
import { SummarizedComplaintsList } from './summarized-complaints-list';

const Flex = styled(DetailsWrapper)`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const ListHeader = styled.div`
  width: 100%;
  margin-bottom: 15px;
  padding-bottom: 5px;
  border-bottom: 1px solid black;
  font-weight: bold;
  font-size: 14px;
`;

export function SummarizedComplaints() {
  const { currentProperty, loading: propertyLoading } = usePropertyDetails();
  const { complaints, loading } = useComplaints();

  if (propertyLoading || loading) {
    return <SummarizedComplaintsSkeleton />;
  }

  return (
    <Wrapper>
      <Flex>
        <StreetAddress>{currentProperty?.address}</StreetAddress>
        <ListHeader>Complaints</ListHeader>
        <SummarizedComplaintsList complaints={complaints} />
      </Flex>
    </Wrapper>
  );
}
